import { QuerySnapshot } from 'firebase/firestore';

type IGetObjectFromCollectionSnapshot = <T>(snapshot: QuerySnapshot) => { [key: string]: T };

export const getObjectFromCollectionSnapshot: IGetObjectFromCollectionSnapshot = (snapshot) =>
    snapshot.docs.reduce((acc, document) => {
        acc[document.id] = document.data();
        return acc;
    }, {} as { [key: string]: any });
